import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Shops from './pages/Shops';
import AllShops from './pages/AllShops';
import SingleShop from './pages/SingleShop';
import Card from './pages/Card';
import Shipping from './pages/Shipping';
import Details from './pages/Details';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import { get_category } from './store/reducers/homeReducer';
import { customer_fetch_me } from './store/reducers/authReducer';
import { useDispatch} from 'react-redux';
import CategoryShop from './pages/CategoryShop';
import SearchProducts from './pages/SearchProducts';
import Payment from './pages/Payment';
import Dashboard from './pages/Dashboard';
import ProtectUser from './utils/ProtectUser';
import Index from './components/dashboard/Index';
import Orders from './components/dashboard/Orders';
import ChangePassword from './components/dashboard/ChangePassword';
import Wishlist from './components/dashboard/Wishlist';
import OrderDetails from './components/dashboard/OrderDetails';
import Delivery from './components/dashboard/Delivery';
import ConfirmOrder from './pages/ConfirmOrder';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import Blog from './pages/Blog';
import BlogDetails from './pages/BlogDetails';
import MobileBottomNav from './components/MobileBottomNav';
import InstallPrompt from './components/InstallPrompt';

function App() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(get_category())
    dispatch(customer_fetch_me())
},[dispatch])


  return (
    <BrowserRouter>
    <div className='md:has-bottom-nav'>
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='/login' element={<Login/>} />
      <Route path='/register' element={<Register/>} />
      <Route path='/forgot-password' element={<ForgotPassword/>} />
      <Route path='/reset-password' element={<ResetPassword/>} />
      <Route path='/verify-email' element={<VerifyEmail/>} />
      <Route path='/shops' element={<Shops/>} />
      <Route path='/all-shops' element={<AllShops/>} />
      <Route path='/shop/:shopId' element={<SingleShop/>} />
      <Route path='/card' element={<Card/>} />
      <Route path='/shipping' element={<Shipping/>} />
      <Route path='/payment' element={<Payment/>} />
      <Route path='/products?' element={<CategoryShop/>} />
      <Route path='/products/search?' element={<SearchProducts/>} />
      <Route path='/product/details/:slug' element={<Details/>} /> 
      <Route path='/order/confirm?' element={<ConfirmOrder/>} /> 
      <Route path='/about' element={<AboutPage/>} />
      <Route path='/contact' element={<ContactPage/>} />
      <Route path='/blog' element={<Blog/>} />
      <Route path='/blog/:slug' element={<BlogDetails/>} />

      <Route path='/dashboard' element={<ProtectUser/>} >
      <Route path='' element={<Dashboard/>} >        
      <Route path='' element={<Index/>} />
      <Route path='my-orders' element={<Orders/>} /> 
      <Route path='change-password' element={<ChangePassword/>} /> 
      <Route path='my-wishlist' element={<Wishlist/>} /> 
      <Route path='order/details/:orderId' element={<OrderDetails/>} /> 
      <Route path='delivery' element={<Delivery/>} /> 
       
       </Route> 
      </Route>
      
       




    </Routes>
    </div>
    <MobileBottomNav />
    <InstallPrompt />
    </BrowserRouter>
  );
}

export default App;
